module.exports = __webpack_public_path__ + "media/2.5e4e07fa.mp3";